import m from 'mithril';
import modalCloseButton from '../../../components/modalCloseButton';

const modal = {
  key: 'SAVE_JOURNEY_MODAL',

  show() {
    $(`#${modal.key}`).modal('show');
  },
  hide() {
    $(`#${modal.key}`).modal('hide');
  },
  oninit({ state }) {
    state.loading = false;
  },
  view({ state }) {
    return m('.modal', { id: modal.key },
      [
        m('.modal-dialog.modal-dialog-centered[role="document"]',
          [
            m('.modal-content',
              [

                m('.modal-body',
                  [
                    m("div", {
                      "class": "btn btn-icon btn-sm btn-active-light-primary ms-2",
                      "data-bs-dismiss": "modal",
                      "aria-label": "Close",
                      style: { float: 'right', "padding-bottom": "20px" }
                    },
                      m(modalCloseButton)
                    ),
                    m('form', [
                      m('div.form-group', [
                        m('label', { style: { fontSize: '24px', fontWeight: 'bold', marginBottom: '10px', marginTop: '10px' } }, 'Start Journey Now?'),
                        m('div', [
                          m('label', { style: { fontSize: '26px', marginRight: '40px' } }, [
                            m('span', { style: { fontSize: '26px', paddingRight: '10px' } }, 'Yes'),
                            m('input[type="radio"][name="startJourney"][value="yes"]', {
                              style: { width: '24px', height: '24px' },
                              onchange(event) {
                                state.startJourney = event.target.value;
                              },
                            }),
                          ]),
                          m('label', { style: { fontSize: '26px', marginRight: '40px' } }, [
                            m('span', { style: { fontSize: '26px', paddingRight: '10px' } }, 'No'),
                            m('input[type="radio"][name="startJourney"][value="no"]', {
                              style: { width: '24px', height: '24px' },
                              onchange(event) {
                                state.startJourney = event.target.value;
                              },
                            }),
                          ]),
                          state.startJourney === 'no' ? [
                            m("br"),
                            m("br"),
                            m("br"),
                            m('div.form-group', [
                              m('label', 'Select Journey Start Date:'),
                              m('input.form-control[type="date"]', {
                                onchange: (e) => state.journeyStartDate = e.target.value,
                                value: state.journeyStartDate,
                                placeholder: 'Select Date'
                              }),
                            ]),
                            m("br"),
                            m('div.form-group', [
                              m('label', 'Select Journey Start Time:'),
                              m('input.form-control[type="time"]', {
                                onchange: (e) => state.journeyStartTime = e.target.value,
                                value: state.journeyStartTime,
                                placeholder: 'Select Time'
                              }),
                            ]),
                          ] : null
                        ]),
                      ]),

                    ]),
                  ]),
                m('.modal-footer',
                  [
                    m('button.btn.btn-primary.btn-block[type="button"][class="w-100"]', {
                      onclick() {
                        modal.hide();
                        selectVehicleModal.show()
                      },
                    }, 'Proceeed'),
                  ]),
              ]),
          ]),
      ]);
  },
};


export default modal;
